import { useState } from "react";
import { supabase } from "@/services/supabase";
import { toast } from "sonner";

/**
 * Hook to trigger Stripe pricing sync from Stripe API to Supabase
 * Call this to refresh pricing data when Stripe prices are updated
 */
export function useSyncStripePricing() {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const syncPricing = async () => {
    try {
      setLoading(true);
      setError(null);

      toast.info('Syncing pricing data from Stripe...');

      const { data, error: functionError } = await supabase.functions.invoke(
        "sync-stripe-products",
        {
          body: {},
        }
      );

      if (functionError) {
        throw new Error(functionError.message);
      }

      if (!data || !data.success) {
        throw new Error(data?.error || "Failed to sync pricing");
      }

      toast.success(
        `Successfully synced ${data.synced.products} products and ${data.synced.prices} prices`
      );

      // Clear pricing cache to force refetch
      sessionStorage.removeItem('stripe_pricing_cache');

      return data;
    } catch (err) {
      const errorMessage = err instanceof Error ? err.message : "Failed to sync pricing";
      setError(errorMessage);
      toast.error(errorMessage);
      throw err;
    } finally {
      setLoading(false);
    }
  };

  return { syncPricing, loading, error };
}
